import PurseReverse from '../../src/legacy/PurseReverse.tsx';
export default PurseReverse;
